export type Sizes = 'small' | 'medium' | 'large';

export const getIconSizes = () => ({ xs: 24, sm: 28, md: 32, lg: 36 });

export const getFooterSizes = () => ({ xs: 64, sm: 96, md: 112, lg: 128 });
